import { useRef } from 'react';
import { useScrollAnimation } from '@/hooks/useScrollAnimation';
import { categories } from '@/mocks/products';
import { useNavigate } from 'react-router-dom';

export default function ProductCategories() {
  const { ref, isVisible } = useScrollAnimation();
  const navigate = useNavigate();

  return (
    <section
      ref={ref as React.RefObject<HTMLElement>}
      className="py-24 px-4 md:px-8"
      style={{ background: 'linear-gradient(180deg, #0E1218 0%, #101828 60%, #0E1218 100%)' }}
    >
      <div className="max-w-7xl mx-auto">
        {/* Header */}
        <div className={`mb-14 reveal ${isVisible ? 'visible' : ''}`}>
          <p className="text-accent text-xs font-semibold tracking-[3px] uppercase mb-3">
            Our Product Range
          </p>
          <h2 className="font-poppins font-bold text-3xl md:text-5xl text-white">
            Product Categories
          </h2>
          <div className="h-1 w-16 bg-accent rounded-full mt-4" />
        </div>

        {/* Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-5">
          {categories.map((cat, i) => (
            <button
              key={cat.id}
              onClick={() => navigate('/products')}
              className={`category-card relative rounded-2xl overflow-hidden cursor-pointer text-left block w-full reveal reveal-delay-${i + 1} ${isVisible ? 'visible' : ''}`}
              style={{ height: '260px' }}
            >
              {/* Background image */}
              <div className="absolute inset-0">
                <img
                  src={cat.image}
                  alt={cat.name}
                  className="cat-img w-full h-full object-cover object-top"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/75 via-black/20 to-transparent" />
              </div>

              {/* Content */}
              <div className="absolute inset-0 p-8 flex flex-col justify-end">
                <div className="w-10 h-10 flex items-center justify-center rounded-full bg-accent/20 border border-accent/30 mb-3">
                  <i className={`${cat.icon} text-accent text-lg`} />
                </div>
                <h3 className="font-poppins font-bold text-2xl text-white mb-1">{cat.name}</h3>
                <p className="text-text-muted text-sm">{cat.count} Products</p>
                <div className="mt-3 flex items-center gap-2 text-accent text-sm font-medium">
                  <span>View Products</span>
                  <i className="ri-arrow-right-line" />
                </div>
              </div>

              {/* Red accent line */}
              <div className="cat-accent-line" />
            </button>
          ))}
        </div>
      </div>
    </section>
  );
}
